import React, { useEffect, useRef, useState } from 'react';
import { SelectComponent, TextComponent, TooltipComponent } from '../../uiComponents';
import { Checkbox, FormControlLabel, SelectChangeEvent } from '@mui/material';
import { OptionProps, SelectPropsData, TextPropsData } from '../../../view-models';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import constants from '../../../constants/constants';
import jsonConstants from '../../../constants/jsonConstants';
import jsonXMLConstants from '../../../constants/jsonXMLConstants';

export interface ResolverSelectorProps {
  changeHandler: any;
  label: string;
  value: string;
  baseResolversOnly?: boolean;
  data?: any;
}

export const resolverStringValid = (rValue: string, baseResolversOnly=false) => {
  if (rValue && jsonConstants.customFieldResolvers.includes(`${rValue.substring(1).split(':')[0]}:`)) {
    return rValue.substring(1, rValue.length - 1).split(':')[1].length > 0;
  } else {
    return (
      rValue &&
      getSessionContextList(baseResolversOnly).some((sc) => {
        return sc.value === rValue;
      })
    );
  }
};

const getSessionContextList = (baseOnly: boolean) => {
  if (baseOnly) {
    return constants.SESSIONCONTEXT.filter((scItem) => {
      return !Object.keys(jsonXMLConstants.sessionContexts.specials).includes(scItem.value);
    })
  } else {
    return constants.SESSIONCONTEXT;
  }
}

export const ResolverSelector = ({ changeHandler, label, value, baseResolversOnly=false, data }: ResolverSelectorProps) => {
  const [resolverBaseField, setResolverBaseField] = useState<string>(
    value
      ? jsonConstants.customFieldResolvers.some((res) => value.substring(1).startsWith(res))
        ? `${value.split(':')[0].substring(1)}:`
        : value
      : getSessionContextList(baseResolversOnly)[0].value,
  );
  useEffect(() => {
    setResolverBaseField(
      value
        ? jsonConstants.customFieldResolvers.some((res) => value.substring(1).startsWith(res))
          ? `${value.split(':')[0].substring(1)}:`
          : value
        : getSessionContextList(baseResolversOnly)[0].value,
    );
  }, [value]);
  return (
    <>
      <SelectComponent
        changeHandler={(e: SelectChangeEvent<string>) => {
          setResolverBaseField(e.target.value);
          changeHandler(e.target.value);
        }}
        data={
          data
            ? {
                ...data,
                value: resolverBaseField ? resolverBaseField : getSessionContextList(baseResolversOnly)[0].value,
                label: label ? label : '',
                options: getSessionContextList(baseResolversOnly),
                style: { margin: 1, width: 250 },
              }
            : {
                value: resolverBaseField ? resolverBaseField : getSessionContextList(baseResolversOnly)[0].value,
                label: label ? label : '',
                options: getSessionContextList(baseResolversOnly),
                style: { margin: 1, width: 250 },
              }
        }
      />
      {jsonConstants.customFieldResolvers.includes(resolverBaseField) && (
        <TextComponent
          changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            changeHandler(`{${resolverBaseField}${e.target.value}}`);
          }}
          data={{
            value: value?.substring(0, value.length - 1)?.split(':')[1]
              ? value?.substring(0, value.length - 1)?.split(':')[1]
              : '',
            label: 'Key',
            style: { margin: 1, width: 250 },
            required: true,
          }}
        />
      )}
    </>
  );
};
